<template>
  <el-form class="target-form" ref="target" :model="targetingParam" label-width="140px">
    <el-form-item label="定向方式" v-if="!isUseAdUnion">
      <RadioGroup v-model="targetingParam.intelli_extend_option" @on-change="onAutoTargetChange" type="button">
        <Radio :label="0">自定义定向</Radio>
        <Radio :label="1">智能定向</Radio>
      </RadioGroup>
    </el-form-item>
    <el-form-item label="地域">
      <RadioGroup v-model="targetingParam.district" type="button">
        <Radio label="NONE">不限</Radio>
        <Radio label="CITY">按省市</Radio>
      </RadioGroup>

      <div style="margin-top: 10px" class="row-max-width-1200px" v-show="targetingParam.district === 'CITY'">
        <CascaderSelector
          v-if="targetingParam.district === 'CITY'"
          v-model="targetingParam.region"
          :options="cityData"
          :props="{ multiple: true, value: 'id', label: 'value' }"
        ></CascaderSelector>
      </div>
    </el-form-item>

    <el-form-item label="性别">
      <RadioGroup v-model="targetingParam.gender" type="button">
        <Radio :label="0">不限</Radio>
        <Radio :label="2">男</Radio>
        <Radio :label="1">女</Radio>
      </RadioGroup>
    </el-form-item>

    <el-form-item label="年龄">
      <RadioGroup v-model="targetingParam.ageMode" type="button">
        <Radio label="NONE">不限</Radio>
        <Radio label="CUSTOM">自定义年龄</Radio>
      </RadioGroup>

      <div v-if="targetingParam.ageMode === 'CUSTOM'">
        <Slider v-model="targetingParam.ageRange" :marks="marks" :step="1" :min="18" :max="75" style="width: 600px" range />
      </div>
    </el-form-item>

    <el-form-item label="人群包">
      <RadioGroup v-model="targetingParam.audienceMode" type="button">
        <Radio label="NONE">不限</Radio>
        <Radio label="AUDIENCE">定向或排除人群</Radio>
      </RadioGroup>

      <div style="margin-top: 10px" class="row-max-width-1200px" v-if="targetingParam.audienceMode === 'AUDIENCE'">
        <AudiencesTable v-model="populations" :data="audiencesData" :accounts="accounts" @change="onAudienceValuechange" />
      </div>
    </el-form-item>

    <template v-if="!targetingParam.intelli_extend_option">
      <el-form-item label="行为意向定向">
        <RadioGroup v-model="targetingParam.behavior_type" type="button">
          <Radio :label="0">不限</Radio>
          <Radio :label="1">自定义</Radio>
          <!-- <Radio :label="2" :disabled="isUseAdUnion">系统优选</Radio> -->
        </RadioGroup>
      </el-form-item>
      <el-form-item label="行为" v-if="targetingParam.behavior_type === 1">
        <!-- 新版 -->
        <div class="row-max-width-1200px">
          <action-interest
            v-model="targetingParam.action_tags"
            :action-scene="targetingParam.action_scene"
            :action-days="targetingParam.action_days"
            :strength="targetingParam.strength_type"
            :task-id="currentTaskId"
            :max="100"
            :accounts="accounts"
            action
            @on-days="updateBehaviorInterestProp('action_days', $event)"
            @on-scene="updateBehaviorInterestProp('action_scene', $event)"
            @on-intensity="updateBehaviorInterestProp('strength_type', $event)"
          />
        </div>
      </el-form-item>
      <el-form-item label="意向" v-if="targetingParam.behavior_type === 1">
        <div class="row-max-width-1200px">
          <action-interest
            :task-id="currentTaskId"
            v-model="targetingParam.word_tags"
            :strength="targetingParam.interest_strength_type"
            :max="100"
            :accounts="accounts"
            @on-intensity="updateBehaviorInterestProp('interest_strength_type', $event)"
          />
        </div>
      </el-form-item>
    </template>

    <el-form-item label="操作系统版本">
      <RadioGroup v-model="targetingParam.platform_os" type="button">
        <Radio :label="0" :disabled="isAndroid || isIOS">不限</Radio>
        <Radio :label="1" :disabled="isAndroid || isIOS">安卓</Radio>
        <Radio :label="2" :disabled="isAndroid || isIOS">iOS</Radio>
      </RadioGroup>
    </el-form-item>

    <el-form-item v-if="targetingParam.platform_os === 1">
      <version v-model="targetingParam.android_osv" :data="androidVersion" title="安卓版本" />
    </el-form-item>

    <el-form-item v-if="targetingParam.platform_os === 2">
      <version v-model="targetingParam.ios_osv" :data="iOSVersion" title="iOS版本" />
    </el-form-item>
    <template v-if="!targetingParam.intelli_extend_option">
      <!--
         设备品牌显示 https://developers.e.kuaishou.com/docs?docType=DSP&documentId=1904
        device_brand_ids
       -->
      <el-form-item label="设备品牌" v-if="isAndroid || isMiniGame">
        <div class="row-max-width-1200px">
          <Mixcheck v-model="targetingParam.device_brand_ids">
            <radio-item :label="0">不限</radio-item>
            <check-item v-for="item in deviceBrand" :key="item.id" :label="item.value">
              {{ item.label }}
            </check-item>
          </Mixcheck>
        </div>
      </el-form-item>

      <el-form-item label="设备价格">
        <Mixcheck v-model="targetingParam.device_price">
          <radio-item :label="0">不限</radio-item>
          <check-item v-for="item in devicePrice" :key="item.id" :label="item.value">
            {{ item.label }}
          </check-item>
        </Mixcheck>
      </el-form-item>

      <el-form-item label="网络">
        <RadioGroup v-model="targetingParam.network" type="button">
          <Radio :label="0">不限</Radio>
          <Radio :label="1">WIFI</Radio>
          <Radio :label="2">移动网络</Radio>
        </RadioGroup>
      </el-form-item>

      <el-form-item label="APP定向" v-show="isAndroid && !isUseAdUnion">
        <RadioGroup v-model="targetingParam.app_behavior" type="button">
          <Radio :label="0">不限</Radio>
          <Radio :label="1">按APP分类</Radio>
          <Radio :label="2">按APP名称</Radio>
        </RadioGroup>

        <div style="margin-top: 10px" class="row-max-width-1200px" v-if="targetingParam.app_behavior === 1">
          <CascaderSelector
            v-model="targetingParam.app_interest_ids"
            filterable
            :options="appCateData"
            :props="{ multiple: true, value: 'id', label: 'value' }"
          ></CascaderSelector>
        </div>

        <div style="margin-top: 10px" class="row-max-width-1200px" v-if="targetingParam.app_behavior === 2">
          <RemoteSearchSelector
            v-model="targetingParam.app_ids"
            :data="remoteAppData"
            :loading="remoteQuering"
            :remote-method="appTargetingRemoteQuery"
            :max="10"
          />
        </div>
      </el-form-item>
    </template>

    <el-form-item label="过滤已转化用户" v-show="!isUseAdUnion">
      <Mixcheck v-model="targetingParam.filter_converted_level">
        <radio-item v-for="item in filterConvertLevel" :key="item.id" :disabled="isLink && item.label === 'APP'" :label="item.value">
          {{ item.label }}
        </radio-item>
      </Mixcheck>
    </el-form-item>
  </el-form>
</template>
<script>
import { getAppSearch, getAppList, getTargetingTags, getPopulationList } from '@/api/kuaishou.model'

import {
  marks,
  androidVersion,
  iOSVersion,
  iosDeviceBrand,
  deviceBrand,
  devicePrice,
  filterConvertLevel,
  audienceEnum
} from '@/data/kuaishou/datas'
import { isArray, deepCopy } from '@/common/js/utils'
import AudiencesTable from './components/audiences-table'
import RemoteSearchSelector from '@/components/remote-search-table'
import ActionInterest from '@/views/create/kuaishou_local/components/actioninterest'
import CascaderSelector from '@/components/cascader-select/index.vue'

import Version from '@/components/version'
import Mixcheck from '@/components/mixcheck'
import RadioItem from '@/components/mixcheck/radio-item'
import CheckItem from '@/components/mixcheck/check-item'

export default {
  components: { AudiencesTable, RemoteSearchSelector, CascaderSelector, ActionInterest, Version, Mixcheck, RadioItem, CheckItem },
  computed: {
    currentTaskId() {
      return this.$store.state.Kuaishou.taskInfo.currTaskId
    },
    formData() {
      return this.$store.getters['Kuaishou/currTaskParams']
    },
    innerForm: {
      get() {
        return this.formData.innerForm
      },
      set(form) {
        this.$store.commit('Kuaishou/UPDATE_INNER_PARAMS', form)
      }
    },
    outterForm() {
      return this.formData.outterForm
    },
    targetingForm: {
      get() {
        return this.formData.targetingForm
      },
      set(form) {
        this.$store.commit('Kuaishou/UPDATE_TARGETING_PARAMS', form)
      }
    },
    targetingParam() {
      return this.targetingForm?.targetingParam || {}
    },
    isAndroid() {
      return this.innerForm.ch_platform_id === 1
    },
    isIOS() {
      return this.innerForm.ch_platform_id === 2
    },
    isMiniGame() {
      return this.innerForm.ch_platform_id === 3
    },
    // 销售线索收集
    isLink() {
      return this.innerForm.landing_type === 'LINK'
    },
    deviceBrand() {
      if (this.targetingParam.platform_os === 0) {
        return [...iosDeviceBrand, ...deviceBrand]
      }
      if (this.targetingParam.platform_os === 1) {
        return deviceBrand
      }
      if (this.targetingParam.platform_os === 2) {
        return iosDeviceBrand
      }
      return []
    },
    accounts() {
      return [
        {
          id: this.formData.ad_account_id,
          name: this.formData.ad_account_name
        }
      ]
    },
    isUseAdUnion() {
      return this.outterForm.union === 1
    },
    emptyRegion() {
      const { district, region } = this.targetingParam
      if (!region.length) {
        this.intelliExtendBreakChange('area_break')
      }
      return district === 'NONE' || !region?.length
    },
    /**
     * @description: 人群包model，转换结构支持组件多账号选择人群包
     */
    populations: {
      get() {
        return this.targetingParam.populations
      },
      set(newModel) {
        const { accountId } = newModel
        const newForm = this.targetingParam
        newForm.populations = {
          ...newForm.populations,
          [accountId]: newModel
        }

        this.targetingForm = {
          ...this.targetingForm,
          targetingParam: newForm
        }
      }
    }
  },
  watch: {
    // 当前批量复制切换账号时，重新根据账号id获取页面数据
    'formData.ad_account_name'() {
      this.preLoadData()
    }
  },
  data() {
    return {
      remoteQuering: false,
      cityData: [], // 城市列表
      appCateData: [], // APP分类列表
      remoteAppData: [], // APP名称分类列表
      audiencesData: [], // 人群包列表
      cating: null, // 加载app名称
      marks, // 年龄标志
      androidVersion,
      iOSVersion,
      // deviceBrand,
      devicePrice,
      filterConvertLevel
    }
  },
  methods: {
    /**
     * @description: 获取已选网红粉丝的key-value，保存到提交参数
     * @description: { id: fan.id, name: fan.name, type: 1 } //type 1 网红粉丝;type 2 快手粉丝
     * @param {*} v
     */
    onFansStarChange(v) {
      const newForm = this.targetingForm
      newForm.targetingParam.fans_star_array = v.map((fan) => ({ id: fan.id, name: fan.name, type: 1 }))
      this.targetingForm = newForm
    },
    /**
     * @description: 智能定向切换
     * @param {*} val
     */
    onAutoTargetChange(val) {},

    /**
     * @description: App名称分类定向列表远程搜索
     * @param {*} querystr
     * @return {*}
     */
    appTargetingRemoteQuery(querystr) {
      const params = { ad_account_id: this.formData.ad_account_id, appName: querystr }
      this.remoteQuering = true
      getAppSearch(params).then((data) => {
        this.remoteQuering = false
        if (data) {
          this.remoteAppData = data.map((ret) => {
            return {
              id: ret.app_id,
              name: ret.app_name
            }
          })
        }
      })
    },

    /**
     * @description: 人群包定向、排除数据设置
     * @description: 定向、排除与付费人群包详情搜索：[paid_audience]  https://developers.e.kuaishou.com/docs?docType=DSP&documentId=1904
     * @param {*} selected
     * @return {*}
     */
    setAudiencesDataState(selected) {
      const { includes: includeList, excludes: excludeList } = selected

      // 在定向和排除结果中，取得第一个选中的属性类型
      const list = includeList.length ? includeList : excludeList
      const [firstId] = list

      const firstRow = this.audiencesData.find((au) => au.orientation_id === firstId)
      let firstType = 0
      let isPaidAudience = false
      if (firstRow?.population_type === 7) {
        firstType = 7
        isPaidAudience = true
      }
      const newForm = Object.assign({}, this.targetingForm, {
        ...this.targetingForm,
        targetingParam: {
          ...this.targetingParam,
          isPaidAudience // 标记是否付费人群包，用做提交修改时判断
        }
      })

      this.targetingForm = newForm

      this.audiencesData = this.audiencesData.map((row) => {
        const newRow = { ...row, includesDisabled: false, excludesDisabled: false }

        // 排除不能选付费
        if (row.population_type === 7) {
          newRow.excludesDisabled = true
          //  智能定向不能选付费
          newRow.includesDisabled = this.targetingParam.intelli_extend_option === 1
        }

        // 定向选了付费包，就全部只能选付费包
        if (firstType === 7) {
          if (row.population_type !== 7) {
            newRow.includesDisabled = true
            newRow.excludesDisabled = true
          }
        }
        // 定向、排除选了非付费包，就不能再选付费包
        // 全部清空时，firstRow 为undefined 不会进入下面的判断条件
        if (firstRow) {
          if (firstType !== 7 && row.population_type === 7) {
            newRow.includesDisabled = true
            newRow.excludesDisabled = true
          }
        }

        return newRow
      })
    },
    /**
     * @description: 快手人群包选中结果变化
     */
    onAudienceValuechange(selected) {
      this.setAudiencesDataState(selected)
    },

    /**
     * @description: 更新行为兴趣定向
     * @param {*} property [action_scene, action_days, strength_type]
     * @param {*} val
     */
    updateBehaviorInterestProp(property, val) {
      const newTargetingForm = Object.assign({}, this.targetingForm, {
        targetingParam: {
          ...this.targetingForm.targetingParam,
          [property]: val
        }
      })
      this.targetingForm = newTargetingForm
    },
    /**
     * @description: 表单校验
     * @return {*} 成功promise.resolve 失败promise.reject
     */
    formValidate() {
      return Promise.resolve()
    },

    preLoadData() {
      // 加载数据源
      const [account] = this.accounts
      const ad_account_id = account?.id
      const requestList = []

      if (ad_account_id) {
        requestList.push(getAppList({ ad_account_id }))
        // 人群包列表
        requestList.push(getPopulationList({ ad_account_id }))
        // APP分类
        requestList.push(getTargetingTags({ ad_account_id, type: 'APP_INTEREST_ID' }))
      }

      if (requestList.length) {
        Promise.all(requestList).then((data) => {
          const [appData, audiencesData, appCateData] = data

          // 构造人群包数据，通过includesDisabled是否禁用定向列，通过excludesDisabled是否禁用排除列
          if (isArray(audiencesData)) {
            this.audiencesData = audiencesData.map((au) => ({
              ...au,
              check: null,
              includesDisabled: false,
              excludesDisabled: false,
              groupId: au.orientation_id,
              groupName: au.orientation_name,
              groupTypeDesc: audienceEnum[au.population_type] || '未知' // 获取属性名
            }))

            // 初始化人群包表格状态
            const populations = deepCopy(this.targetingParam.populations)
            this.setAudiencesDataState(populations[ad_account_id])
          }

          this.appCateData = isArray(appCateData) ? appCateData.map((app) => ({ ...app, value: app.name })) : []

          if (isArray(appData) && appData.length) {
            this.appAndList = appData.filter((ret) => ret.platform === 1)

            const [ids] = this.innerForm.app_ids
            ids.account_id = ad_account_id
            ids.iOSAppData = appData.filter((ret) => ret.platform === 3)

            const innerForm = Object.assign({}, this.innerForm, {
              app_ids: [ids]
            })
            this.innerForm = innerForm
          }
        })
      }
    }
  },

  created() {
    // 城市列表数据
    fetch('/data/kuaishou_cities.json')
      .then((res) => res.json())
      .then((cities) => (this.cityData = cities))

    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped>
.row-max-width-1200px {
  max-width: 1200px;
}
</style>
